<template>
  <form
    class="input-wrapper"
    @submit.prevent="handleSearch"
  >
    <input
      v-model="inputText"
      placeholder="Show me next season's best-selling red women's shoes under €200"
      class="input"
    >
    <button
      type="submit"
      :class="{ 'circular-btn': true, 'circular-btn-visible': inputText.length > 0 }"
    >
      <arrow-up-icon
        v-if="!isLoading"
        size="24"
      />
      <spinner-icon
        v-else
        class="spinner-icon-slow scaled-spinner"
      />
    </button>
  </form>
</template>
<script>
import { ArrowUpIcon } from 'vue-feather-icons'
import SpinnerIcon from '@core/assets/svg-components/SpinnerIcon.vue'

export default {
  name: 'RetailerAiInput',
  components: {
    ArrowUpIcon,
    SpinnerIcon,
  },
  props: {
    onSearch: {
      type: Function,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputText: '',
      isLoading: false,
    }
  },
  watch: {
    loading(val) {
      // Sync parent-controlled loading with local state
      this.isLoading = val
    },
  },
  methods: {
    async handleSearch() {
      if (!this.inputText.trim()) return

      this.isLoading = true
      document.activeElement?.blur()

      try {
        await this.onSearch(this.inputText)
        this.$emit('success')
      } catch (e) {
        this.$emit('error')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
<style scoped lang="scss">
.input-wrapper {
  position: relative;
  max-width: 971px;
  width: 100%;
}

.input {
  padding: 18px 20px;
  border: 1px solid #E0E0E0;
  border-radius: 25px;
  background: #fff;
  width: 100%;
  font-size: 20px;
  line-height: 24px;
  height: 85px;

  &:focus {
    outline: none;
  }
}

.circular-btn-visible {
  opacity: 1 !important;
}

.scaled-spinner {
  transform: scale(1.3);
}

.circular-btn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  color: #fff;
  font-size: 24px;
  line-height: 24px;
  opacity: 0;
  transition: opacity 0.3s ease;
}
</style>
